import { render, staticRenderFns } from "./griddy.vue?vue&type=template&id=768ce49d&scoped=true&"
import script from "./griddy.vue?vue&type=script&lang=js&"
export * from "./griddy.vue?vue&type=script&lang=js&"
import style0 from "./griddy.vue?vue&type=style&index=0&id=768ce49d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ce49d",
  null
  
)

export default component.exports